// Librairies
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

// Services
import { SynthesisStore } from 'src/app/services/stores/synthesis.store';

// Interfaces
import { NamedRef, Tenant } from 'src/app/interfaces/api/company';

// Components
import { addSynthesisWidget } from 'src/app/components/main-pages/synthesis/shared/synthesis-dashboard/synthesis-dashboard.component';
import { ActionGroupComponent, ButtonComponent } from 'ui-library';

interface SynthesisTab {
  route: string;
  label: string;
  icon: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-synthesis',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    TranslateModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    ActionGroupComponent,
    ButtonComponent,
  ],
  templateUrl: './synthesis.component.html',
  styleUrl: './synthesis.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class SynthesisComponent {
  // Services
  readonly store: SynthesisStore = inject(SynthesisStore);
  private readonly router: Router = inject(Router);
  private readonly dialog: MatDialog = inject(MatDialog);

  // Variables
  readonly tabs: SynthesisTab[] = [
    { route: 'prevention', label: 'synthesis.prevention.title', icon: 'health_and_safety' },
    { route: 'production', label: 'synthesis.production.title', icon: 'insights' },
    { route: 'safety', label: 'synthesis.safety.title', icon: 'crisis_alert' },
    { route: 'environment', label: 'synthesis.environment.title', icon: 'eco' },
  ];

  // Signals
  readonly tenant: Signal<Tenant<NamedRef> | null> = this.store.tenant;
  readonly tenants: Signal<Tenant<NamedRef>[]> = this.store.tenants;

  // Not a routerLink: lib-button stops the click propagation, so a routerLink on its host never fires.
  back(): void {
    this.router.navigate(['/synthesis']);
  }

  refresh(): void {
    this.store.refreshWidgets();
  }

  addWidget(): void {
    addSynthesisWidget(this.dialog, this.store);
  }
}
